import { UnstyledButton } from '@src/components/base/Buttons'
import { getCheckCategoryPath } from '@src/layouts/shared/NavTabs/utils'
import { setShouldSubmitOnload } from '@src/state/expertcheck/actions'
import { isDemoSelector } from '@src/state/router/selectors'
import { RootState } from '@src/state/types'
import { userInteract } from '@src/state/userevents/actions'
import {
  BUTTON,
  CLICK,
  EXPECT_CHECK_TEXT,
  EXPERT_CHECK_CTA_ELEMENT,
  UNSUPPORTED_CLAIMS_EC_ORIGIN,
  UNSUPPORTED_CLAIMS_REGION,
} from '@src/state/userevents/actions'
import { getUploadId } from '@src/state/workspace/selectors'
import { getCardAcceptTestId } from '@src/utils/dataTestIds/getters'
import { push } from 'connected-react-router'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import styled from 'styled-components'
import {
  ReplacementButtonStyle,
  ReplacementButtonWrapper,
  VisuallyHidden,
} from './styles'

export const EXPERT_CHECK_CTA_ID = 'expert-check-cta'
export const EXPERT_CHECK_CTA_COPY = 'Get an expert check'
export const FIXED_COPY = 'I fixed it myself'

export const FixedClaimButton = styled(UnstyledButton)`
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.text.size.sm};
  color: ${({ theme }) => theme.colors.link};
  text-decoration: none;
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-left: ${({ theme }) => theme.spacing.sm};
  &:hover {
    text-decoration: underline;
  }
`

interface UCButtonStateProps {
  paperId: string
  isDemo: boolean
}

interface UCButtonDispatchProps {
  onCtaClick: (path: string) => void
}

interface UCButtonProps {
  index: number
  id: string
  'aria-labelledby': string
  acceptText: string
  handleAccept?: () => void
  isDisabled?: boolean
}
type Props = UCButtonStateProps & UCButtonDispatchProps & UCButtonProps

const UnsupportedClaimsButtons: React.FC<Props> = ({
  index,
  id,
  'aria-labelledby': ariaLabelledBy,
  isDisabled,
  acceptText,
  handleAccept,
  onCtaClick,
  paperId,
  isDemo,
}) => {
  const onClick = () =>
    onCtaClick(
      getCheckCategoryPath({
        checkCategory: 'expert-check',
        paperId,
        isDemo,
      })
    )

  return (
    <ReplacementButtonWrapper>
      <ReplacementButtonStyle
        data-test={EXPERT_CHECK_CTA_ID}
        disabled={!!isDisabled}
        onClick={onClick}
      >
        {EXPERT_CHECK_CTA_COPY}
      </ReplacementButtonStyle>
      <FixedClaimButton
        onClick={() => !isDisabled && handleAccept && handleAccept()}
        data-test={getCardAcceptTestId(acceptText)}
        aria-labelledby={`--accept-label-${index}-${id} ${ariaLabelledBy}`}
      >
        {FIXED_COPY}
        <VisuallyHidden id={`--accept-label-${index}-${id}`}>
          I fixed the unsupported claim
        </VisuallyHidden>
      </FixedClaimButton>
    </ReplacementButtonWrapper>
  )
}

const mapStateToProps = (state: RootState): UCButtonStateProps => ({
  paperId: getUploadId(state),
  isDemo: isDemoSelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch): UCButtonDispatchProps => ({
  onCtaClick: path => {
    dispatch(setShouldSubmitOnload({ shouldSubmit: true }))

    dispatch(
      userInteract({
        origin: UNSUPPORTED_CLAIMS_EC_ORIGIN,
        element: EXPERT_CHECK_CTA_ELEMENT,
        type: BUTTON,
        text: EXPECT_CHECK_TEXT,
        region: UNSUPPORTED_CLAIMS_REGION,
        interactionType: CLICK,
      })
    )
    dispatch(push(path))
  },
})

export default connect<UCButtonStateProps, UCButtonDispatchProps, UCButtonProps>(
  mapStateToProps,
  mapDispatchToProps
)(UnsupportedClaimsButtons)



// WEBPACK FOOTER //
// ./src/components/Cards/UnsupportedClaimsButtons.tsx